import React, { FunctionComponent } from 'react';
import { ListItemSecondaryAction } from '@mui/material';

import TemplateAction, { SecondaryAction } from './TemplateAction';

interface Props {
  template: any;
  actions?: SecondaryAction[];

  onLeft?: boolean;
}

const TemplateActions: FunctionComponent<Props> = ({ template, actions, onLeft }) => {
  if (actions == null) {
    return null;
  }

  const actionsToDisplay = actions.filter((action) => (onLeft ? action.alignLeft : !action.alignLeft));
  if (actionsToDisplay.length === 0) {
    return null;
  }

  const Container = onLeft ? 'span' : ListItemSecondaryAction;
  return (
    <Container>
      {actionsToDisplay.map((action) => (
        <TemplateAction template={template} action={action} key={action.key} />
      ))}
    </Container>
  );
};

export default TemplateActions;
